export default {
  MuiCheckbox: {
    root: {
      fontSize: '18px',
    },
  },
};
